import { render, staticRenderFns } from "./LocationEditor.vue?vue&type=template&id=1120790c"
import script from "./LocationEditor.vue?vue&type=script&lang=js"
export * from "./LocationEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports